export default class ActiveCampaign {
    constructor(el) {
        this.el = el
        this.setSource()
        this.setUTMS()
        this.removeStyles()
    }

    setSource() {
        this.el.querySelectorAll('[value="{{source}}"]').forEach((el) => el.value = window.location.href)
    }

    removeStyles() {
        this.el.querySelectorAll('style').forEach((el) => el.remove())
    }

    setUTMS() {
        const queryString = new URLSearchParams(window.location.search);

        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((utm) => {
            const utmValue = queryString.get(utm)

            this.el.querySelectorAll('[value="{{' + utm + '}}"]')
                .forEach((el) => el.value = !utmValue ? 'Not set' : utmValue)
        })
    }
}
